export default {
  executionHistory: {
    title: 'Logs',
    refresh: 'Refresh',
    filter: {
      execution_id: 'Execution ID',
      req_id: 'Request ID',
      workflow: 'Workflow',
      workflowPlaceholder: 'Workflow Name',
      version: 'Version',
      protocol: 'Protocol',
      protocolPlaceholder: 'Protocol Name',
      env: 'Environment',
      timeRange: 'Time Range',
      startTime: 'Start Time',
      endTime: 'End Time',
      clientInfo: 'Client Info',
      selectField: 'Select Field',
      inputValue: 'Please input value',
      add: 'Add',
      reset: 'Reset',
      columnManagement: 'Column Management',
      placeholder: 'Please input',
      sortByStartTime: 'Sort by Start Time',
      earliest: 'Earliest',
      latest: 'Latest',
      allStatus: 'All Status',
      status: 'Status',
      triggerBy: 'Trigger By',
      all: 'All',
      knitConsole: 'Knit Console',
      api: 'API',
      schedule: 'Schedule',
      webhook: 'Webhook',
      customAttributes: 'Custom Attributes',
      value: 'Value',
      resetAll: 'Reset ALL',
    },
    clientFields: {
      gameid: 'Game ID',
      protouid: 'Protocol UID',
      sessionid: 'Session ID',
      userid: 'User ID',
      requestid: 'Request ID',
    },
    table: {
      columns: {
        execution_info: 'Execution Info',
        req_id: 'Request ID',
        env: 'Environment',
        status: 'Execution Result',
        client_info: 'Client Info',
        duration: 'Duration',
        created_at: 'Execution Time',
        session_id: 'Session ID',
        publish_version: 'Version',
        protocol: 'Protocol',
        start_time: 'Start Time',
        run_time: 'Run Time',
        execution_id: 'Execution ID',
        trigger_by: 'Trigger By',
        custom_attributes: 'Custom Attributes',
      },
      status: {
        success: 'success',
        error: 'error',
      },
      unknownWorkflow: 'Unknown Workflow',
      executedAt: 'Executed at',
      noValue: 'None',
      query: 'Query',
      executionIdLabel: 'Execution ID',
      requestIdLabel: 'Request ID',
    },
    shortcuts: {
      last1Hour: 'Last 1 Hour',
      last6Hours: 'Last 6 Hours',
      last12Hours: 'Last 12 Hours',
      last1Day: 'Last 1 Day',
      last3Days: 'Last 3 Days',
      last7Days: 'Last 7 Days',
    },
    messages: {
      selectField: 'Please select a field',
      inputValue: 'Please input filter value',
      successExport: 'Successfully exported {count} records',
      errorExport: 'Export failed, please try again',
    },
  },
  executionDetail: {
    title: 'Execution Record',
    details: 'Execution Details',
    protocol: 'Protocol',
    env: 'Environment',
    scheduleInterval: 'Schedule Interval',
    duration: 'Duration',
    updatedAt: 'Updated at',
    createdAt: 'Created at',
    goToWorkflow: 'To Workflow',
    viewLogs: 'View Logs',
    actions: {
      backToLogs: 'Back to Logs',
      backToRunTasks: 'Back to Run Tasks',
      saveAsTestCase: 'Save as a test case',
    },
    messages: {
      loadFailed: 'Failed to load execution record details',
      loadSubWorkflowFailed: 'Failed to get sub-workflow nodes',
    },
  },
  saveExecuteExample: {
    saveAsExample: 'Save as Example',
    exampleName: 'Example Name',
    exampleNamePlaceholder: 'Please enter example name',
    exampleCatalog: 'Example Catalog',
    exampleCatalogPlaceholder: 'Please enter example catalog',
  },
  executionLog: {
    nodeConfig: 'View Node Config',
    more: 'More',
    subWorkflowExecutionRecord: 'Sub-workflow Execution Record',
    subWorkflowConfig: 'Sub-workflow Config',
    tabs: {
      result: 'Output Result',
      detail: 'Details',
      prompt: 'Prompt',
      raw: 'Raw Data',
    },
    titlePostfix: 'Execution Log',
    noLoopLog: 'No loop node log found',
    recordTitle: 'Execution {index}',
    details: {
      nodeName: 'Node Name',
      nodeDescription: 'Node Description',
      nodeId: 'Node ID',
      nodeType: 'Node Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      duration: 'Duration',
      status: 'Status',
      errorMsg: 'Error Message',
      outputVariables: 'Output Variables',
      inputVariables: 'Input Variables',
      modelName: 'Model Name',
      modelProvider: 'Model Provider',
      promptTokens: 'Prompt Tokens',
      completionTokens: 'Completion Tokens',
      totalTokens: 'Total Tokens',
      executionTime: 'Execution Time',
      outputData: 'Output Data',
      rawResult: 'Raw Execution Result',
      noRawData: 'No raw data',
      noOutputData: 'No output data',
    },
    status: {
      success: 'Success',
      completed: 'Completed',
      failed: 'Failed',
      error: 'Error',
      ready: 'Ready',
      waiting: 'Waiting',
      running: 'Running',
      skipped: 'Skipped',
    },
  },
  executionDrawer: {
    title: 'Execution Record Details',
    tabs: {
      result: 'Output Result',
      detail: 'Details',
      trace: 'Trace',
    },
    workflowName: 'Workflow Name',
    unknownWorkflow: 'Unknown Workflow',
    executionId: 'Execution ID',
    requestId: 'Request ID',
    sessionId: 'Session ID',
    env: 'Environment',
    protocol: 'Protocol',
    triggerType: 'Trigger Type',
    inputParams: 'Input Parameters',
    outputResult: 'Output Result',
    noNodeRecords: 'No node execution records',
    nodeData: 'Node Data',
    childNodes: 'Child Nodes',
    messages: {
      loadFailed: 'Failed to load execution details',
    },
  },
};
